// extracted by mini-css-extract-plugin
export default {"tabs":"style_tabs__+6Dz4","square":"style_square__QoqVz","tab":"style_tab__Y3N7G","circle":"style_circle__mzb-I","icon":"style_icon__1kYcI","active":"style_active__q9dmG"};